import React from 'react';
import {
  Container,
  Corner,
  OverlayBox,
  QRWrapper,
  StyledUnder,
  StyledWallet,
  SubContainer,
  SubTitle,
} from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Wallet/styles';
import SvgImage from '@/components/Module/SvgImage';
import { StyledSVGButton } from '@/styles/GlobalStyles';
import { useGetQrCode } from '@/hooks/apiHooks';
import { isIOS } from '@/utils/userEnv';
import QRCode from 'react-qr-code';

const Wallet = () => {
  const useGetAppleWallethandleDownload = async () => {
    const sendData = JSON.stringify({
      actionType: 'WALLET',
    });
    window?.ReactNativeWebView?.postMessage(sendData);
  };

  const sendNfcNumber = async () => {
    const sendData = JSON.stringify({
      actionType: 'NFC',
      cardNumber: data?.cardNumber,
    });
    window?.ReactNativeWebView?.postMessage(sendData);
  };

  const { data } = useGetQrCode();

  return (
    <>
      {isIOS(window.navigator.userAgent) ? (
        <>
          <Container>
            <SubTitle>
              <StyledWallet>
                Wallet
                <StyledUnder />
              </StyledWallet>
              {
                '에 출입증 등록을 해두면\n휴대폰의 Wallet으로도 사옥 출입을 할 수 있어요.'
              }
            </SubTitle>
            <div
              style={{
                width: '240px',
                aspectRatio: '8/9',
                overflow: 'hidden',
              }}
            >
              <img
                src={'/images/dummy/default-passport.png'}
                style={{
                  width: '100%',
                  height: '100%',
                  transform: 'translateY(3px)',
                  objectFit: 'cover',
                }}
              />
            </div>
          </Container>
          <SubContainer>
            <div>{'아래 버튼을 눌러\nWallet에 출입증을 등록해주세요.'}</div>
            <StyledSVGButton onClick={useGetAppleWallethandleDownload}>
              <SvgImage name={'wallet_apple'} />
            </StyledSVGButton>
          </SubContainer>
        </>
      ) : (
        <div style={{ marginTop: '96px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {data?.cardNumber && (
              <QRWrapper>
                <QRCode size={165} value={data.cardNumber} />
                <OverlayBox>
                  <Corner position="topLeft" />
                  <Corner position="topRight" />
                  <Corner position="bottomLeft" />
                  <Corner position="bottomRight" />
                </OverlayBox>
              </QRWrapper>
            )}
          </div>
          <div
            style={{
              padding: '24px 0',
              backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
              textAlign: 'center',
              whiteSpace: 'pre-wrap',
              marginTop: '48px',
              fontSize: '14px',
              lineHeight: '24px',
            }}
          >
            {
              '휴대폰 뒷면을 리더기 가까이에 대거나,\n위 QR코드를 찍어 사옥 출입을 할 수 있어요.'
            }
          </div>
          {/*{data?.cardNumber && (*/}
          {/*  <button*/}
          {/*    style={{*/}
          {/*      display: 'flex',*/}
          {/*      backgroundColor: 'var(--dk-bg, white)',*/}
          {/*      color: 'var(--dk-text, black)',*/}
          {/*      border: '1px solid var(--dk-line, #E7E9EC)',*/}
          {/*      textAlign: 'center',*/}
          {/*      alignItems: 'center',*/}
          {/*      justifyContent: 'center',*/}
          {/*      padding: '12px',*/}
          {/*      width: '80%',*/}
          {/*      margin: '24px auto 0 auto',*/}
          {/*    }}*/}
          {/*    onClick={sendNfcNumber}*/}
          {/*  >*/}
          {/*    <div*/}
          {/*      style={{ width: '20px', height: '20px', marginRight: '8px' }}*/}
          {/*    >*/}
          {/*      <SvgImage name={'nfc'} />*/}
          {/*    </div>*/}
          {/*    NFC 등록*/}
          {/*  </button>*/}
          {/*)}*/}
        </div>
      )}
    </>
  );
};

export default Wallet;
